// extracted by mini-css-extract-plugin
export default {"Categories":"RequestInformation_Categories__zFN0-","RequestType":"RequestInformation_RequestType__d8QOv","ProductGroup":"RequestInformation_ProductGroup__usH6R"};